import axios from 'axios';
import apiConfig from '../api.config';

export default function getPoliceConfig({ hotelId }) {
  const {
    host,
    URIs: { policeReport, policeReportConfig },
  } = apiConfig;

  const uri = `${host}${policeReport}/${policeReportConfig.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
